const enum AppEnv {
  Development = `development`,
  Production = `production`,
  Test = `test`,
}

function getAppEnv(): string {
  return typeof APP_ENV !== `undefined` ? APP_ENV : AppEnv.Development;
}

export function isDevEnv(): boolean {
  return getAppEnv() === AppEnv.Development;
}

export function isTestEnv(): boolean {
  return getAppEnv() === AppEnv.Test;
}

export function isProdEnv(): boolean {
  return getAppEnv() === AppEnv.Production;
}

export function isBrowserEnv(): boolean {
  return typeof window !== `undefined`;
}

/**
 * Environment label for stamping onto external-vendor payloads and the events
 * we emit for them (e.g. Frigade conversations), so non-production traffic is
 * filterable in vendor dashboards and in Mixpanel. APP_ENV alone cannot
 * distinguish staging from production — staging serves production builds — so
 * staging is detected from the hostname (same approach as tracking-setup.ts).
 *
 * @lintignore (knip) TODO(GRO-253): temporarily unreferenced — consumed by the Frigade loader, which stamps this onto `userProperties.environment`
 */
export function getEnvironmentLabel(): string {
  if (!isProdEnv()) {
    return getAppEnv();
  }
  if (isBrowserEnv() && /^staging(-eu|-in)?-\d+\.mixpanel\.com$/.test(window.location.hostname)) {
    return `staging`;
  }
  return AppEnv.Production;
}

export function isStandalone(): boolean {
  return typeof mp === `undefined`;
}

export function isLocalOrigin(): boolean {
  // temp: treat codespaces as local environment for standalone iron dev. will remove when we have nginx
  return (
    [`localhost`, `127.0.0.1`].includes(window.location.hostname) ||
    window.location.hostname.endsWith(`.app.github.dev`)
  );
}

export function isLocalhostDevEnv() {
  return isBrowserEnv() && isDevEnv() && isLocalOrigin();
}

export function isMixpanelDotCom() {
  if (!isBrowserEnv()) {
    return false;
  }
  const domain = window.location.hostname;
  return /\bmixpanel\.com$/.test(domain);
}

// mockable export
export const envUtils = {isProdEnv, isTestEnv};
